import { Button, Grid2 } from "@mui/material";
import React from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export const buttonsCellRenderer = (params: any) => {
	const {
		setUserId,
		setOpenModalEditDataUser,
		setOpenModalDeleteUser,
		setOpenModalChangePasswordd,
		showContextMenu,
	} = params;

	return (
		<Grid2
			container
			sx={{
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				opacity: 0,
				transition: "opacity 0.1s ease-in-out",
				".ag-row-hover &": {
					opacity: 1,
				},
				".ag-row-focus &": {
					opacity: 1,
				},
				".ag-row-selected &": {
					opacity: 1,
				},
			}}
		>
			<Grid2
				size={{ md: 12, xs: 12 }}
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Button
					onClick={() => {
						(async () => {
							setUserId(params.data.UserId);
							setOpenModalChangePasswordd(true);
						})();
					}}
				>
					<LockOutlinedIcon style={{ height: "auto" }} color="primary" />
				</Button>
				<Button
					onClick={() => {
						(async () => {
							setUserId(params.data.UserId);
							setOpenModalEditDataUser(true);
						})();
					}}
				>
					<EditIcon style={{ height: "auto" }} color="primary" />
				</Button>
				<Button
					onClick={() => {
						(async () => {
							setUserId(params.data.UserId);
							setOpenModalDeleteUser(true);
						})();
					}}
				>
					<DeleteIcon style={{ height: "auto" }} color="secondary" />
				</Button>
				<Button
					style={{}}
					onClick={(e) => {
						showContextMenu(e, params.data, "TableUsers");
					}}
				>
					<FormatListBulletedSharpIcon
						style={{ height: "auto" }}
						color="action"
					/>
				</Button>
			</Grid2>
		</Grid2>
	);
};
